var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Petty Cash Basic Services")]),_c('p',[_vm._v("Manage basic petty cash services from here.")])])
}]

export { render, staticRenderFns }